export default "__VITE_ASSET__DhEiu5sM__"